/* global PRODUCTION */

// Setup tealium

// Local imports
import * as datalayer_dispatch from './init.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'tealium';

export let global_vars = {};

// --------------------------------------------------------------------------
//
// --------------------------------------------------------------------------
// Initialize Tealium
// Note: the original was an anonymous function that defined (a, b, c, d) as
// parameters
// Note2: this is currently unused
function init_tealium(env) {
    let a = '//tags.tiqcdn.com/utag/worldvisionca/central/' + env + '/utag.js';
    let b = document;
    let c = 'script';
    let d = b.createElement(c);
    d.src = a;
    d.type = 'text/java' + c;
    d.async = true;
    a = b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d, a);
}

export function wrap_module_array(modules) {
    // Note: PRODUCTION variable is defined in webpack config
    let env = 'qa';
    if (PRODUCTION) {
        env = 'prod';
    }

    let all_modules = [datalayer_dispatch];
    all_modules.push.apply(all_modules, modules);

    function initialize() {
        init_tealium(env);
    }

    let tealium_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(tealium_mod);

    return all_modules;
}
